import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { API_ROOT } from './config'

// import { toFormdata } from '../constants/global/util'

Vue.use(VueAxios, axios)

// user
export const getUserToken = (config) => Vue.axios.get(API_ROOT + 'users/current_user', { params: config })
// main
export const postSendContact = (data, config) => Vue.axios.post(API_ROOT + 'contact/send_contact_mail_jp', data, { params: config })
export const postSendReservation = (data, config) => Vue.axios.post(API_ROOT + 'contact/send_reservation', data, { params: config })
export const postDatasheetInfo = (data, config) => Vue.axios.post(API_ROOT + 'datasheet_info', data, { params: config })



// WEBPACK FOOTER //
// ./src/api/index.js